/**
 * `/admin/automation` — the ADDIS status board, mirroring `/a7y-addis-status`:
 * three tables grouped by the job to be done, one row per workflow file, and
 * the production chain as the release pipeline's own summary.
 *
 * The AI quota table used to sit below this board and now has its own page
 * (A7Y-3812). It was never part of the same question: this page answers "did
 * the automation run, and did it pass", which is about the past; quota answers
 * "can the next cycle run at all", which is about capacity. Two questions on
 * one page meant scrolling past sixteen workflow rows to reach the one figure
 * that predicts whether anything will happen next.
 */
import { PageHeader } from '@/components/PageHeader';
import { AddisStatusBoard } from './AddisStatusBoard';

export default function AddisStatusPage() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="ADDIS Status"
        subtitle="Platform health, the release pipeline and the dev pipeline — one row per workflow, with its recent run outcomes. Composed server-side from GitHub Actions, Linear and git. Times in your timezone."
      >
        <div className="text-xs text-zinc-500">Board polls 60s</div>
      </PageHeader>

      <AddisStatusBoard />
    </div>
  );
}
